// assets
import { IconFileText, IconLifebuoy, IconSettingsCog } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - OPERATIONS (P4-2) ||============================== //

const operations: NavItemType = {
  id: 'operations',
  title: 'operations', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconSettingsCog,
  type: 'group',
  requiredModule: 'operations',
  children: [
    {
      id: 'operations-documents',
      title: 'operations-documents',
      icon: IconFileText,
      type: 'item',
      url: '/operations/documents',
      module: 'operations.documents'
    },
    {
      id: 'operations-tickets',
      title: 'operations-tickets',
      icon: IconLifebuoy,
      type: 'item',
      url: '/operations/tickets',
      module: 'operations.tickets'
    }
  ]
};

export default operations;
